"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleOLMap = exports.ToggleBaseLayerControl = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/*
 * SimpleOLMAp.tsx
 * Author: lnappenfeld
 * Date: 05.10.2022
 *
 * Copyright: DMT GmbH & Co. KG
 */
const react_1 = __importStar(require("react"));
const ol_1 = require("ol");
const Tile_1 = __importDefault(require("ol/layer/Tile"));
const Vector_1 = __importDefault(require("ol/layer/Vector"));
const Vector_2 = __importDefault(require("ol/source/Vector"));
const OSM_1 = __importDefault(require("ol/source/OSM"));
const control_1 = require("ol/control");
require("ol/ol.css");
const geom_1 = require("ol/geom");
const style_1 = require("ol/style");
const style_2 = require("ol/style");
const interaction_1 = require("ol/interaction");
const Circle_1 = __importDefault(require("ol/style/Circle"));
const spatialservice_npm_1 = require("@dmt/spatialservice_npm");
require("../style/SimpleOLMap.css");
const source_1 = require("ol/source");
class ToggleBaseLayerControl extends control_1.Control {
    /**
     * @param {Object} [opt_options] Control options.
     */
    constructor(opt_options) {
        const options = opt_options || {};
        const button = document.createElement('button');
        button.setAttribute('id', 'toggleBaseLayerButton');
        button.innerHTML = 'S';
        button.title = 'Sat/Strasse';
        const element = document.createElement('div');
        element.className = 'toggle-base-layer ol-unselectable ol-control';
        element.appendChild(button);
        super({
            element: element,
            target: options.target,
        });
        button.addEventListener('click', this.toggleBaseLayer.bind(this), false);
    }
    toggleBaseLayer(e) {
        e.preventDefault();
        const baseLayer = this.getMap().getLayers().getArray()[0];
        const button = document.getElementById('toggleBaseLayerButton');
        if (baseLayer.getSource() instanceof OSM_1.default) {
            baseLayer.setSource(new source_1.XYZ({
                attributions: ['Powered by Esri',
                    'Source: Esri, DigitalGlobe, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community'],
                url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
            }));
            button.innerHTML = 'O';
        }
        else {
            baseLayer.setSource(new OSM_1.default());
            button.innerHTML = 'S';
        }
    }
}
exports.ToggleBaseLayerControl = ToggleBaseLayerControl;
/**
 * Map
 * The map is the core component of OpenLayers. For a map to render, a view, one or more layers, and a target container
 * are needed.
 *
 * View
 * The view determines how the map is rendered. It is used to set the resolution, the center location, etc. It is like
 * a camera through which we look at the map’s content.
 *
 * Layers
 * Layers can be added to the map in a stacked order. Layers can be either raster layers (images), or vector layers
 * (points/lines/polygons).
 *
 * Source
 * Each layer has a source, which knows how to load the layer content. In the case of vector layers, its source reads
 * vector data using a format class (for example GeoJSON or KML) and provides the layer with a set of features.
 *
 * Features
 * Features represent real world things and can be rendered using different geometries (like point, line or polygon)
 * using a given style, which determines its look (line thinkness, fill color, etc).
 *
 * A Map has layers -> A Layer has a source -> A Source has features
 */
function SimpleOLMap(props) {
    const [map, setMap] = (0, react_1.useState)();
    const [featuresLayer, setFeaturesLayer] = (0, react_1.useState)(new Vector_1.default({}));
    const [allLocationsLayer, setAllLocationsLayer] = (0, react_1.useState)(new Vector_1.default({}));
    const [feature, setFeature] = (0, react_1.useState)(null);
    const [allVisibleLocations, setAllVisibleLocations] = (0, react_1.useState)([]);
    const mapElement = (0, react_1.useRef)();
    const mapRef = (0, react_1.useRef)();
    mapRef.current = map;
    const getAllLocationsStyle = (location) => {
        console.log('location: ', location.location_name);
        const zoom = props.center.location_zoom;
        return new style_2.Style({
            text: zoom < 17 ? null : new style_1.Text({ text: location.location_name, textAlign: 'center', textBaseline: 'top', offsetY: 10, font: 'bold 15px sans-serif' }),
            image: new style_1.Circle({
                fill: new style_2.Fill({
                    color: 'rgb(64, 64, 64)'
                }),
                radius: 5,
            })
        });
    };
    (0, react_1.useEffect)(() => {
        // Zeige den Namen als Text der anderen Punkte nur über einem Zoomlevel von 17
        updateAllLocationsStyle();
        if (map)
            map.getView().setZoom(props.center.location_zoom);
    }, [props.center.location_zoom]);
    const updateAllLocationsStyle = () => {
        if (allLocationsLayer.getSource()) {
            const features = allLocationsLayer.getSource().getFeatures();
            for (let i = 0; i < features.length; i++) {
                const _feature = features[i];
                const _location = allVisibleLocations[i];
                if (_location) {
                    const style = getAllLocationsStyle(_location);
                    _feature.setStyle(style);
                }
            }
        }
    };
    const addAllLocations = (layer) => __awaiter(this, void 0, void 0, function* () {
        const allLocations = [];
        for (const location of props.locations) {
            // continue, if position or epsg code is null
            if (!location.geo_position_x || !location.geo_position_y || !location.epsg_code)
                continue;
            // show all, but not the current location which should be edited
            if (location.location_id === props.location.location_id)
                continue;
            const transformedLocation = location;
            if (location.epsg_code) {
                const coords = [location.geo_position_x, location.geo_position_y, location.geo_position_z];
                const transformedCoords = yield (0, spatialservice_npm_1.transformCoords)(coords, location.epsg_code, 3857);
                // console.log('srcCode: ', props.location.epsg_code);
                // console.log('desCode: ', 3857);
                // console.log('coordinates: ', coords);
                // console.log('transformedCoords: ', transformedCoords);
                transformedLocation.geo_position_x = transformedCoords[0];
                transformedLocation.geo_position_y = transformedCoords[1];
                transformedLocation.geo_position_z = transformedCoords[2];
            }
            const feature = new ol_1.Feature({
                // geometry: new Point(fromLonLat([props.location.geo_position_x, props.location.geo_position_y])),
                geometry: new geom_1.Point([transformedLocation.geo_position_x, transformedLocation.geo_position_y]),
                name: props.location.name,
            });
            feature.setStyle(getAllLocationsStyle(transformedLocation));
            layer.getSource().addFeature(feature);
            allLocations.push(transformedLocation);
        }
        console.log('Anzahl features: ', layer.getSource().getFeatures().length);
        console.log('Anzahl locations: ', allLocations.length);
        setAllVisibleLocations(allLocations);
    });
    // mounting useEffect
    (0, react_1.useEffect)(() => {
        console.log('SimpleOLMap');
        console.log(props.center);
        const center = props.center;
        // create and add vector source layer
        const source = new Vector_2.default();
        const initialFeaturesLayer = new Vector_1.default({
            source: source,
            zIndex: 10
        });
        const initialAllLocationsLayer = new Vector_1.default({
            source: new Vector_2.default(),
            zIndex: 10
        });
        (() => __awaiter(this, void 0, void 0, function* () {
            yield addAllLocations(initialAllLocationsLayer);
        }))();
        const interactions = [];
        if (!props.location.location_id) {
            // Add drawing interaction if new location should be created
            const draw = new interaction_1.Draw({
                type: 'Point',
                source: source,
                style: new style_2.Style({
                    image: new Circle_1.default({
                        radius: 5,
                        fill: new style_2.Fill({ color: 'black' }),
                    }),
                }),
            });
            draw.on('drawend', (event) => {
                console.log('drawend');
                const _feature = event.feature;
                const coordinates = _feature.getGeometry().getCoordinates();
                console.log(coordinates);
                _feature.setStyle(new style_2.Style({
                    text: new style_1.Text({ text: props.location.location_name, textAlign: 'center', textBaseline: 'top', offsetY: 10, font: 'bold 15px sans-serif' }),
                    image: new style_1.Circle({
                        fill: new style_2.Fill({
                            color: 'rgb(255,0,0)'
                        }),
                        stroke: new style_2.Stroke({
                            color: '#4b8cad',
                            width: 1.25,
                        }),
                        radius: 9,
                    })
                }));
                setFeature(_feature);
                console.log('----------------------------');
                console.log(_feature.getGeometry().getType());
                // update input field in formular
                // props.onPositionChange(toLonLat(coordinates));
                props.onPositionChange([coordinates[0], coordinates[1], 0.0]);
                initialMap.removeInteraction(draw);
            });
            interactions.push(draw);
        }
        else {
            // Show current feature if current location should be updated
            (() => __awaiter(this, void 0, void 0, function* () {
                const mp = props.location;
                if (props.location.epsg_code) {
                    const coords = [props.location.geo_position_x, props.location.geo_position_y, props.location.geo_position_z];
                    const transformedCoords = yield (0, spatialservice_npm_1.transformCoords)(coords, props.location.epsg_code, 3857);
                    console.log('srcCode: ', props.location.epsg_code);
                    console.log('desCode: ', 3857);
                    console.log('coordinates: ', coords);
                    console.log('transformedCoords: ', transformedCoords);
                    mp.geo_position_x = transformedCoords[0];
                    mp.geo_position_y = transformedCoords[1];
                    mp.geo_position_z = transformedCoords[2];
                }
                const feature = new ol_1.Feature({
                    // geometry: new Point(fromLonLat([props.location.geo_position_x, props.location.geo_position_y])),
                    geometry: new geom_1.Point([mp.geo_position_x, mp.geo_position_y]),
                    name: props.location.name,
                });
                feature.setStyle(new style_2.Style({
                    text: new style_1.Text({ text: props.location.location_name, textAlign: 'center', textBaseline: 'top', offsetY: 10, font: 'bold 15px sans-serif' }),
                    image: new style_1.Circle({
                        fill: new style_2.Fill({
                            color: 'rgb(255,0,0)'
                        }),
                        stroke: new style_2.Stroke({
                            color: '#4b8cad',
                            width: 1.25,
                        }),
                        radius: 9,
                    })
                }));
                initialFeaturesLayer.getSource().addFeature(feature);
            }))();
        }
        // Add modify interaction
        const modify = new interaction_1.Modify({
            source: source,
            style: new style_2.Style({
                image: new Circle_1.default({
                    radius: 5,
                    fill: new style_2.Fill({ color: 'black' }),
                }),
            }),
        });
        modify.on('modifyend', (event) => {
            console.log('modifyend');
            if (!event.features || event.features.getArray().length <= 0)
                return;
            const _features = event.features.getArray();
            const coordinates = _features[0].getGeometry().getCoordinates();
            // update input field in formular
            // props.onPositionChange(toLonLat(coordinates));
            // props.onPositionChange(coordinates);
            props.onPositionChange([coordinates[0], coordinates[1], 0.0]);
        });
        interactions.push(modify);
        // create map
        const initialMap = new ol_1.Map({
            controls: (0, control_1.defaults)({
                attribution: false,
                fullscreen: true,
                zoom: true
            }).extend([
                new control_1.Attribution({ collapsible: false }),
                new ToggleBaseLayerControl()
            ]),
            target: mapElement.current,
            layers: [
                new Tile_1.default({
                    source: new OSM_1.default(),
                }),
                initialFeaturesLayer,
                initialAllLocationsLayer
            ],
            view: new ol_1.View({
                projection: 'EPSG:3857',
                // center: fromLonLat([center.geo_position_x, center.geo_position_y]), // Long, Lat
                center: [center.geo_position_x, center.geo_position_y],
                zoom: center.location_zoom,
            }),
        });
        // add interactions to map
        for (const interaction of interactions) {
            initialMap.addInteraction(interaction);
        }
        let currZoom = initialMap.getView().getZoom();
        initialMap.on('moveend', function (e) {
            const newZoom = initialMap.getView().getZoom();
            if (currZoom !== newZoom) {
                console.log('zoom end, new zoom: ' + newZoom);
                currZoom = newZoom;
                props.onZoomChange(newZoom);
            }
        });
        // console.log(initialMap);
        setMap(initialMap);
        setFeaturesLayer(initialFeaturesLayer);
        setAllLocationsLayer(initialAllLocationsLayer);
    }, []);
    const setFeatureText = (feature) => {
        const image = feature.getStyle().image_;
        feature.setStyle(new style_2.Style({
            text: new style_1.Text({ text: props.location.location_name, textAlign: 'center', textBaseline: 'top', offsetY: 10, font: 'bold 15px sans-serif' }),
            image: image
        }));
    };
    // Aktualisiere Feature, da die aktuellen Werte bei draw.on('drawend') noch nicht vorhanden sind...
    (0, react_1.useEffect)(() => {
        if (feature) {
            setFeatureText(feature);
        }
    }, [feature]);
    // update map if features prop changes - logic formerly put into componentDidUpdate
    (0, react_1.useEffect)(() => {
        if (props.location && props.location.geo_position_x && props.location.geo_position_y && featuresLayer) { // may be null on first render
            const mp = props.location;
            console.log('useEffect 2');
            console.log(mp);
            (() => __awaiter(this, void 0, void 0, function* () {
                if (props.location.epsg_code) {
                    const coords = [props.location.geo_position_x, props.location.geo_position_y, props.location.geo_position_z];
                    const transformedCoords = yield (0, spatialservice_npm_1.transformCoords)(coords, props.location.epsg_code, 3857);
                    console.log('srcCode: ', props.location.epsg_code);
                    console.log('desCode: ', 3857);
                    console.log('coordinates: ', coords);
                    console.log('transformedCoords: ', transformedCoords);
                    mp.geo_position_x = transformedCoords[0];
                    mp.geo_position_y = transformedCoords[1];
                    mp.geo_position_z = transformedCoords[2];
                }
                if (featuresLayer.getSource()) {
                    console.log(featuresLayer.getSource().getFeatures());
                    const _features = featuresLayer.getSource().getFeatures();
                    if (_features.length > 0) {
                        const _feature = _features[0];
                        // old
                        // _feature.setGeometry(new Point(fromLonLat([mp.geo_position_x, mp.geo_position_y])));
                        _feature.setGeometry(new geom_1.Point([mp.geo_position_x, mp.geo_position_y]));
                        const image = _feature.getStyle().image_;
                        _feature.setStyle(new style_2.Style({
                            text: new style_1.Text({
                                text: props.location.location_name,
                                textAlign: 'center',
                                textBaseline: 'top',
                                offsetY: 10,
                                font: 'bold 15px sans-serif'
                            }),
                            image: image
                        }));
                    }
                }
            }))();
            // fit map to feature extent (with 100px of padding)
            // map.getView().fit(featuresLayer.getSource().getExtent(), {
            //     padding: [100, 100, 100, 100],
            //     // maxZoom: 20
            // });
        }
    }, [props.location]);
    return ((0, jsx_runtime_1.jsx)("div", { style: { height: '100%', width: '100%' }, ref: mapElement, className: "map-container" }));
}
exports.SimpleOLMap = SimpleOLMap;
